import { InlineText2 } from '@cian/ui-kit';
import { mergeStyles } from '@cian/utils';
import * as React from 'react';
import * as stylesCommon from '../FiltersCommon/FiltersCommon.css';
import * as styles from './FilterRefineDetails.css';

export const FilterRefineDetails = () => {
  return (
    <div {...mergeStyles(stylesCommon['container'], styles['container'])}>
      <InlineText2 color="gray40_100">← Чтобы уточнить детали, выберите город</InlineText2>
    </div>
  );
};
